import { useShallow } from 'zustand/react/shallow';

import { ArrowPositions } from '@/apps/mwd-v2/state/types/TooltipStore';
import { WerklijnLegendRight } from '@/apps/mwd-v2/types/legends';
import useClientState from '@/state/useClientState';
import { formatTime } from '@/utils/dateUtils';

import styles from './MwdTooltip.module.css';

const LegendRightTooltipInformation = ({ data }) => {
  const dagLabel =
    data.isNietVolgendeVerkeersdag && data.dagAfkorting ? `${data.dagAfkorting.toLowerCase()}` : 'Morgen';
  return (
    <div style={{ lineHeight: '20px' }}>
      <div data-testid='treinnummer' style={{ fontWeight: 500, display: 'inline' }}>
        {data.claimsoort !== null ? `Claim: ${data.claimsoort}` : data.treinnummer}
        {data.inzetPositie && `-${data.inzetPositie}`}
        {data.opzending && ' ='}
      </div>
      <div data-testid='omloop' style={{ display: 'inline', fontWeight: 400 }}>
        {data.versterkt ? '+' : ` (${data.omloop})`}
      </div>
      {data.claimsoort !== null ? (
        <div data-testid='vertrektijd' className='no-wrap'>
          Locatie: {dagLabel} {formatTime(new Date(data?.vertrekTijd))} - {data?.dienstregelpuntVan}
          {data?.vertrekVertragingToelichting && (
            <span data-testid='vertraging' style={{ color: 'var(--tractie-color-content-error)' }}>
              {` ${data?.vertrekVertragingToelichting}`}
            </span>
          )}
        </div>
      ) : (
        <div data-testid='vertrektijd' className='no-wrap'>
          Vertrek: {dagLabel} {formatTime(new Date(data?.vertrekTijd))} - {data?.dienstregelpuntVan}
          {data?.vertrekVertragingToelichting && (
            <span data-testid='vertraging' style={{ color: 'var(--tractie-color-content-error)' }}>
              {` ${data?.vertrekVertragingToelichting}`}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

const LegendRightTooltipContent = ({
  data,
  arrowPosition,
}: {
  data: WerklijnLegendRight;
  arrowPosition: ArrowPositions;
}) => {
  const isDetailPanelOpen = useClientState(useShallow((state) => (state.showDetailPanel ? 'DetailPanelOpen' : '')));
  return (
    <div
      data-testid='right-legend-tooltip'
      className={
        arrowPosition === 'bottom'
          ? styles[`legendRightBottomTooltipStyle${isDetailPanelOpen}`]
          : styles[`legendRightTopTooltipStyle${isDetailPanelOpen}`]
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span>
          <LegendRightTooltipInformation data={data} />
        </span>
      </div>
    </div>
  );
};

export default LegendRightTooltipContent;
